<script lang="ts">
	import FakBaseLayout from '../fak/FakBaseLayout.svelte'
	import { mapFormControls } from '../fak/utils/fakStores'

	window.addEventListener('openMapFormProject', (e: CustomEvent) => {
		$mapFormControls.projectId = e.detail.projectId
		$mapFormControls.level = 1
	})

	window.addEventListener('openMapFormProjectLot', (e: CustomEvent) => {
		$mapFormControls.projectId = e.detail.projectId
		$mapFormControls.lotId = e.detail.lotId
		$mapFormControls.level = 1
	})
</script>

<div>
	<div
		class="map-form-control"
		style="opacity: {$mapFormControls.level > 0 ? '1' : '0'}; position: {$mapFormControls.level > 0
			? 'fixed'
			: 'unset'};"
	>
		{#if $mapFormControls.level > 0}
			<FakBaseLayout />
		{/if}
	</div>
</div>

<style>
	.map-form-control {
		position: fixed;
		z-index: 1000002; /* This will also overlay the Google Maps footer in the bottom right with z-index 1000001 */
		transition: opacity 0.5s ease-out;
		backdrop-filter: brightness(40%);
		inset: 0 0 0 0;
	}
</style>
